// Copyright (c) 2021 Deere & Company

import './index.scss';

import AtpCalendarDetail from './atpCalendarDetail';
import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function AtpCalendarDetailPage () {

    return (
        <AuthenticatedPage className="atp-page atp-calendar-detail-page">
            <AtpCalendarDetail />
        </AuthenticatedPage>
    );

}
AtpCalendarDetailPage.displayNAme = 'AtpCalendarDetailPage';

export default AtpCalendarDetailPage;
